import React from "react";
import styled from "styled-components";

const VoidDropdownWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "width" && prop !== "$position",
})<{ width: string; $position?: "left" | "right" }>`
  z-index: 10;
  position: absolute;
  overflow: hidden;
  ${({ $position }) => ($position === "left" ? "left: 0;" : "right: 0;")}
  margin-top: 0.5rem;
  min-width: ${(props) => props.width};
  border-radius: 17px;
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.theme.colors["display-dropdown-background-color"]};
  border: 1px solid
    ${(props) => props.theme.colors["display-dropdown-border-color"]};
`;

type ActionVoidDropdownProps = {
  readonly width: string;
  readonly children: React.ReactNode;
  /**
   * Position of the dropdown relative to the trigger button.
   * @default "right"
   */
  position?: "left" | "right";
};
export default function ActionVoidDropdown(props: ActionVoidDropdownProps) {
  return (
    <VoidDropdownWrapper width={props.width} $position={props.position}>
      {props.children}
    </VoidDropdownWrapper>
  );
}
